import React from 'react'
import TodayDate from '../TodayDate'

const HeaderDashboard = () => {
  return (
    <div>
        <h1 className="text-3xl font-semibold">Selamat Datang, Admin !</h1>
        <div className="flex items-center justify-between mt-3">
            <div className="text-xl text-slate-500">Semoga harimu menyenangkan 👋</div>
            <TodayDate />
        </div>
        <div className="w-full my-6 border"></div>
    </div>
  )
}

export default HeaderDashboard